import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ZapIcon from '@zapsa/zap-icons';

class EnvironmentView extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.autoNextSlide = ::this.autoNextSlide;
    this.getFeatures = ::this.getFeatures;

    this.state = {
      currentFeatures: 0,
    };

    this.autoNextSlide();
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  getFeatures() {
    return [
      { name: () => this.props.translations['env.multiLang'], icon: 'companySquare--lines' },
      { name: () => this.props.translations['env.chat'], icon: 'messages--lines' },
      { name: () => this.props.translations['features.groups'], icon: 'openSquare--lines' },
      { name: () => this.props.translations['env.notifications'], icon: 'notifications--lines' },
      { name: () => this.props.translations['env.mailers'], icon: 'mailers--lines' },
      { name: () => this.props.translations['env.pages'], icon: 'book-marked--lines' },
      { name: () => this.props.translations['env.quickLinks'], icon: 'files-linked--lines' },
      { name: () => this.props.translations['env.mustRead'], icon: 'mustRead--lines' },
      { name: () => this.props.translations['env.videos'], icon: 'video-clip--lines' },
      { name: () => this.props.translations['env.bookings'], icon: 'calendar-check--lines' },
      { name: () => this.props.translations['env.files'], icon: 'files/folder--lines' },
      { name: () => this.props.translations['env.polls'], icon: 'graph-bar--lines' },
      { name: () => this.props.translations['env.galleries'], icon: 'image--lines' },
      { name: () => this.props.translations['env.events'], icon: 'events--lines' },
      { name: () => this.props.translations['env.news'], icon: 'news--lines' },
      { name: () => this.props.translations['env.locations'], icon: 'pin--lines' },
      { name: () => this.props.translations['env.announcements'], icon: 'announcements--lines' },
      { name: () => this.props.translations['env.publicContent'], icon: 'content-broadcast--lines' },
      { name: () => this.props.translations['env.digest'], icon: 'computer-mail--lines' },
    ];
  }

  autoNextSlide() {
    this.timeout = setTimeout(() => {
      this.setState(
        prevState => ({
          currentFeatures:
            prevState.currentFeatures + 4 > this.getFeatures().length ? 0 : prevState.currentFeatures + 4,
        }),
        () => {
          this.autoNextSlide();
        },
      );
    }, 5000);
  }

  render() {
    return (
      <div
        style={{
          width: '100vw',
          overflow: 'hidden',

          background: '#F6F6F6',
        }}
      >
        <div className="container">
          <div className="container-title">{this.props.translations['env.completeEnvironment']}</div>
          <div className="features-container">
            <ZapIcon
              icon="arrowLeft--solid"
              className="u-cursor"
              onClick={() => {
                clearTimeout(this.timeout);
                this.setState(
                  prevState => ({
                    currentFeatures:
                      prevState.currentFeatures - 4 < 0
                        ? this.getFeatures().length - (this.getFeatures().length % 4)
                        : prevState.currentFeatures - 4,
                  }),
                  () => {
                    this.autoNextSlide();
                  },
                );
              }}
            />
            {this.getFeatures()
              .slice(this.state.currentFeatures, this.state.currentFeatures + 4)
              .map(feature => (
                <div className="feature-container">
                  <ZapIcon icon={feature.icon} />
                  <div>{feature.name()}</div>
                </div>
              ))}
            <ZapIcon
              icon="arrowRight--solid"
              className="u-cursor"
              onClick={() => {
                clearTimeout(this.timeout);
                this.setState(
                  prevState => ({
                    currentFeatures:
                      prevState.currentFeatures + 4 > this.getFeatures().length ? 0 : prevState.currentFeatures + 4,
                  }),
                  () => {
                    this.autoNextSlide();
                  },
                );
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default EnvironmentView;
